import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import { getSpecificIcon } from '../../helpers/producttypes.js';
import { DropdownOpenedIcon , DropdownClosedIcon} from '../../icons'
import styles from './defaultStyles';

class SubcategorySelector extends Component {

  handleChange = (subCategoryName) => {
    const { onChange, selectedAttributes } = this.props;
    const isChecked = this.isItemChecked(selectedAttributes, subCategoryName);
    let values = [...selectedAttributes];
    if (isChecked) {
      values.splice(values.indexOf(subCategoryName), 1);
    } else {
      values.push(subCategoryName);
    }
    onChange(values);
  };

  getIcon = (name) => {
    const { selectedAttributes, selectedItemColor, bodyTextColor } = this.props;
    const isChecked = this.isItemChecked(selectedAttributes, name);
    const color = isChecked ? selectedItemColor : bodyTextColor;
    return getSpecificIcon(name, color);
  }
  
  renderCategories = () => {
    const { selectedCategories, subcategories, selectedAttributes, selectedItemColor, bodyTextColor } = this.props;
   return selectedCategories.map(categoryName => (
        <div key={categoryName} style={{display: (subcategories[categoryName].length > 0 ? '' : 'none')}}>
          <CategoryNameDiv color={bodyTextColor}>{categoryName.toLowerCase()}</CategoryNameDiv>
          <Hr />
          <SubCatWrapDiv itemsLength={subcategories[categoryName].length}>
            {subcategories[categoryName].map(subCatName => (
              <SubCatDiv 
                key={subCatName}
                bodyTextColor={bodyTextColor}
                color={this.isItemChecked(selectedAttributes, subCatName) ? selectedItemColor : bodyTextColor} 
                onClick={this.handleChange.bind(null, subCatName)}>{subCatName.toLowerCase()}
              </SubCatDiv>
            ))}
          </SubCatWrapDiv>
        </div>
      ))
  }

  isItemChecked(selectedValues, subCategoryName) {
    return selectedValues && selectedValues.indexOf(subCategoryName) > -1;
  }

  headerIcon(isOpened, checkIconColor) {
    return (
      <HeaderIconWrapperDivStyled>
        {isOpened && <DropdownOpenedIcon style={styles.dropDownIcon} />}
        {!isOpened && <DropdownClosedIcon style={styles.dropDownIcon} />}
      </HeaderIconWrapperDivStyled>
    )
  }

  render() {
    const { selectedCategories, selectedItemColor, bodyTextColor } = this.props;
    return (
       <CategoryWrapperDivStyled>
          <HeaderDivStyled color={bodyTextColor} onClick={this.props.onClick}>Subcategories{this.headerIcon(this.props.isOpened, selectedItemColor)}</HeaderDivStyled>
          { this.props.isOpened && 
            <SlideDownDiv itemsLength={selectedCategories.length}>
              { this.renderCategories() }
            </SlideDownDiv>
          }
       </CategoryWrapperDivStyled>
    ) 
  }
}

SubcategorySelector.propTypes = {
  onClick: PropTypes.func,
  isOpened: PropTypes.bool,
  selectedItemColor: PropTypes.string,
  bodyTextColor: PropTypes.string,
  subcategories: PropTypes.object,
  selectedCategories: PropTypes.array,
  selectedAttributes: PropTypes.array,
  onChange: PropTypes.func,
}

export default SubcategorySelector;

const SlideDownDiv = styled.div `
    height: 100%;
    margin: 5px 0 0 0;
`;

const CategoryWrapperDivStyled = styled.div `
  padding: 5px 0;
  width: 100%;
`;

const HeaderDivStyled = styled.div `
   text-align: center;
   cursor: pointer;
   font-weight: 400;
   font-size: 16px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: ${props => props.color};
`;

const HeaderIconWrapperDivStyled = styled.div `
  padding-top: 3px;
`;

const SubCatWrapDiv = styled.div ` 
  display: flex;
  flex-direction: column;
  width: 250px;
  flex-wrap: wrap;
  height: 100px;
  height: ${props => { 
    if (props.itemsLength <= 4) {
      return '58px';
    } else if (props.itemsLength <= 6) {
        return '88px';
    } else if (props.itemsLength <= 9) {
        return '147px';
    } else if (props.itemsLength <= 12) {
        return '177px';
    } 
  }}; 
  margin: 0 auto;
`;

const SubCatDiv = styled.div ` 
  text-transform: capitalize;
  margin-bottom: 10px;
  cursor: pointer;
  color: ${props => props.color ? props.color : props.bodyTextColor };
`;

const CategoryNameDiv = styled.div ` 
  text-transform: capitalize;
  color: ${props => props.color};
`;

const Hr = styled.div ` 
    display: block;
    height: 0px;
    border: 0;
    border-top: 2px solid #f4f4f4;
    margin: 4px 0 15px;
    padding: 0;
`;


// WEBPACK FOOTER //
// ./src/components/SubcategorySelector/SubcategorySelector.jsx